import { Component } from 'react';
import warning from '../tiny-warning';
import RouterContext from './RouterContext';
import { RoutingContextBridge } from '../../internal/RoutingContextBridge';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The public API for putting history on context.
 */
class Router extends Component {
  static computeRootMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  }
  constructor(props) {
    super(props);
    this._isMounted = false;
    this._pendingLocation = null;
    this.state = {
      location: props.history.location
    };

    // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.
    this.unlisten = props.history.listen(location => {
      this._pendingLocation = location;
    });
  }
  componentDidMount() {
    this._isMounted = true;
    if (this.unlisten) {
      // Any pre-mount location changes have been captured at
      // this point, so unregister the listener.
      this.unlisten();
    }
    this.unlisten = this.props.history.listen(location => {
      if (this._isMounted) {
        this.setState({
          location
        });
      }
    });
    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  }
  componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  }
  render() {
    return /*#__PURE__*/_jsx(RouterContext.Provider, {
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname)
      },
      children: /*#__PURE__*/_jsx(RoutingContextBridge, {
        history: this.props.history,
        location: this.state.location,
        children: this.props.children || null
      })
    });
  }
}
if (process.env.NODE_ENV !== 'production') {
  Router.prototype.componentDidUpdate = function (prevProps) {
    warning(prevProps.history === this.props.history, 'You cannot change <Router history>');
  };
}
export default Router;